import { GenieAvatar } from "@/components/GenieAvatar";

export default function ConsumerGenieCTA() {
  return (
    <section className="w-full py-16 md:py-24 bg-white">
      <div className="w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row items-center justify-center">
        {/* Left Column: Text Content */}
        <div className="md:w-1/2 text-center md:text-left mb-12 md:mb-0 md:pr-6 lg:pr-12">
          <div className="max-w-lg mx-auto md:mx-0 md:ml-auto">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-indigo-900 mb-4">Try a Genie Right Now</h2>
            <p className="text-lg text-slate-600 mb-8">
              Ready to see how it works? Start a conversation with one of our genies and experience the magic of instant, helpful
              assistance.
            </p>
            <a
              href="/live-agent/hq-onboarding"
              className="inline-block px-8 py-3 bg-gradient-to-r from-blue-500 to-purple-500 hover:from-blue-600 hover:to-purple-600 text-white font-semibold rounded-lg shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-300 text-lg"
            >
              Start Talking to a Genie
            </a>
          </div>
        </div>

        {/* Right Column: Animated Genie Image */}
        <div className="md:w-1/2 flex justify-center items-center">
          <div className="max-w-xs mx-auto">
            <a href="/live-agent/hq-onboarding" target="_blank" rel="noopener noreferrer" className="transform block scale-75 lg:scale-90">
              <GenieAvatar speaking={true} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
